// src/components/LinksManagerImageUtils.js
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase";

// Function to resize image before upload
export const resizeImage = (file, maxWidth = 800, maxHeight = 800, quality = 0.85) => {
  return new Promise((resolve, reject) => {
    // Create file reader
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        // Calculate new dimensions
        let width = img.width;
        let height = img.height;
        
        if (width > maxWidth || height > maxHeight) {
          if (width > height) {
            if (width > maxWidth) {
              height = Math.round(height * (maxWidth / width));
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width = Math.round(width * (maxHeight / height));
              height = maxHeight;
            }
          }
        }
        
        // Create canvas and resize
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        
        // Get file type
        const mimeType = file.type || 'image/jpeg';
        
        // Convert to blob
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error('Canvas to Blob conversion failed'));
              return;
            }
            
            // Create a new file from the blob
            const resizedFile = new File(
              [blob], 
              file.name, 
              { type: mimeType }
            );
            
            resolve(resizedFile);
          },
          mimeType,
          quality
        );
      };
      img.onerror = (error) => {
        reject(error);
      };
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });
};

// Direct function to upload image to Firebase Storage
export const uploadImageToStorage = async (userId, linkId, file) => {
  if (!file) throw new Error("No file provided");

  try {
    console.log(`Processing image for link ${linkId}...`);
    
    // Check file size
    const fileSizeMB = file.size / (1024 * 1024);
    console.log(`Original file size: ${fileSizeMB.toFixed(2)} MB`);
    
    // Resize image if needed
    let imageToUpload = file;
    if (fileSizeMB > 2 || file.width > 1200 || file.height > 1200) {
      console.log("Image is large, resizing...");
      imageToUpload = await resizeImage(file, 800, 800, 0.85);
      const newSizeMB = imageToUpload.size / (1024 * 1024);
      console.log(`Resized file size: ${newSizeMB.toFixed(2)} MB`);
    }

    // Create a unique file path with timestamp to prevent caching issues
    const fileExtension = file.name.split(".").pop();
    const fileName = `link-images/${userId}_${linkId}_${Date.now()}.${fileExtension}`;
    const imageRef = ref(storage, fileName);

    // Upload the file
    const snapshot = await uploadBytes(imageRef, imageToUpload);
    console.log("Image uploaded successfully:", snapshot);

    // Get download URL
    const imageUrl = await getDownloadURL(imageRef);
    console.log("Image URL retrieved:", imageUrl);

    return imageUrl;
  } catch (error) {
    console.error("Error in uploadImageToStorage:", error);
    throw error;
  }
};